import { getFirstFocusable, getLastFocusable, focusAsync } from '@stardust-ui/react-bindings';
export var focusMenuItem = function focusMenuItem(menuRef, order) {
  var element = order === 'first' ? getFirstFocusable(menuRef, menuRef.firstElementChild, true) : getLastFocusable(menuRef, menuRef.lastElementChild, true);
  focusAsync(element);
};